var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 14.6663H2.66683C2.31321 14.6663 1.97407 14.5259 1.72402 14.2758C1.47397 14.0258 1.3335 13.6866 1.3335 13.333V8.66634C1.3335 8.31272 1.47397 7.97358 1.72402 7.72353C1.97407 7.47348 2.31321 7.33301 2.66683 7.33301H4.66683M9.3335 5.99967V3.33301C9.3335 2.80257 9.12278 2.29387 8.74771 1.91879C8.37264 1.54372 7.86393 1.33301 7.3335 1.33301L4.66683 7.33301V14.6663H12.1868C12.5084 14.67 12.8204 14.5573 13.0654 14.349C13.3105 14.1407 13.4719 13.8509 13.5202 13.533L14.4402 7.53301C14.4692 7.34191 14.4563 7.1468 14.4024 6.96118C14.3485 6.77556 14.2549 6.60387 14.1281 6.45802C14.0012 6.31216 13.8442 6.19563 13.6679 6.11649C13.4915 6.03734 13.3001 5.99749 13.1068 5.99967H9.3335Z",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.2a7d0417edf1d39c5fa5b338db255947.svg";
export { ForwardRef as ReactComponent };